import { useState } from 'react'
import ContactForm from '@/components/ContactForm'
import type { ContactFormValues } from '@/types'

const contactInfo = {
  email: 'elhorconcriollo@gmail.com',
  phone: '+54 299 672-7809',
  instagram: '@Elhorconcriollo',
}

function Contacto() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitError, setSubmitError] = useState<string | undefined>(undefined)
  const [submitSuccess, setSubmitSuccess] = useState(false)

  const handleSubmit = async (formData: ContactFormValues) => {
    setIsSubmitting(true)
    setSubmitError(undefined)
    setSubmitSuccess(false)

    try {
      const response = await fetch('https://el-horcon-backend.elhorconcriollo.workers.dev/api/contacto', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })

      const result = await response.json()

      if (result.status === 'error') {
        const message = result.details ? `${result.message}: ${Object.values(result.details).join(', ')}` : result.message
        throw new Error(message || 'Error al enviar el formulario')
      }

      setSubmitSuccess(true)
      setTimeout(() => setSubmitSuccess(false), 5000)
    } catch (error) {
      setSubmitError(error instanceof Error ? error.message : 'Error al enviar el formulario')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen bg-background">
      <section className="page-hero h-64 md:h-80 flex items-center justify-center">
        <img
          src="/Docs/Fotos/Horcon foto.png"
          alt="Veterinario atendiendo contacto"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary/60"></div>
        <h1 className="relative text-3xl md:text-4xl font-bold text-white">Contacto</h1>
      </section>

      <section className="py-12 md:py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <ContactForm
                onSubmit={handleSubmit}
                isSubmitting={isSubmitting}
                submitError={submitError}
              />

              {submitSuccess && (
                <div className="mt-4 p-4 bg-success/10 text-success rounded-lg">
                  <p className="font-medium">¡Mensaje enviado correctamente!</p>
                  <p className="text-sm mt-1">Nuestro equipo se pondrá en contacto contigo pronto.</p>
                </div>
              )}
            </div>

            <div className="space-y-6">
              <div className="glass-card rounded-lg p-6 bg-primary/5 hover:float transition-all duration-300 cursor-pointer">
                <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
                  <i className="ph ph-envelope text-primary mr-2"></i>
                  Email
                </h3>
                <p className="text-text-secondary">{contactInfo.email}</p>
              </div>

              <div className="glass-card rounded-lg p-6 bg-primary/5 hover:float transition-all duration-300 cursor-pointer">
                <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
                  <i className="ph ph-phone text-primary mr-2"></i>
                  Teléfono
                </h3>
                <p className="text-text-secondary">{contactInfo.phone}</p>
              </div>

              <div className="glass-card rounded-lg p-6 bg-primary/5 hover:float transition-all duration-300 cursor-pointer">
                <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
                  <i className="ph ph-instagram-logo text-primary mr-2"></i>
                  Instagram
                </h3>
                <p className="text-text-secondary">{contactInfo.instagram}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Contacto